import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

export function CircularProgressWithLabel(props) {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      {/* Background gray circle */}
      <CircularProgress
        variant="determinate"
        value={100}
        sx={{
          color: (theme) => theme.palette.grey[300], // light gray background
        }}
        size={props.size || 40}
      />

      {/* Foreground progress circle */}
      <CircularProgress
        variant="determinate"
        aria-label="Upload photos"
        {...props}
        sx={{
          color: (theme) => theme.palette.primary.main, // your active color
          position: 'absolute',
          left: 0,
        }}
        size={props.size || 40}
      />

      {/* Centered label */}
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="caption"
          component="div"
          sx={{ color: 'text.secondary' }}
        >
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}
